import _get from 'lodash/get'
import { Map, fromJS } from 'immutable'
import {
  DELETE_SECTION,
  DELETE_SECTION_PROCESSING,
  SET_SECTION_DATA,
  SET_SECTIONS_DATA,
  SET_SECTIONS_PROCESSING,
  UPDATE_SECTION_SUCCESS,
  SET_ONBOARD_DATA,
  SET_LIST_SORT_ORDER_OPTIONS,
  SET_DISPLAY_MODE_OPTIONS,
  SET_SECTION_TEMP_VISIBILITY_DATA,
  SET_TOPICS_DATA,
  SET_CONTENT_REFERENCE_TYPES,
  SET_CONTENT_FILTERS,
} from './actions'

export const initialState = Map()

export default (state = initialState, action) => {
  const { payload, type } = action
  switch (type) {
    case SET_SECTIONS_PROCESSING:
      return state
        .set('processing', _get(payload, 'processing', true))
    case SET_SECTIONS_DATA:
      return state
        .set('sections', payload.data)
        .setIn(['processing'], false)
    case SET_SECTION_DATA: {
      const sectionId = payload.get('id')
      return state
        .setIn(['sections', sectionId], payload)
        .setIn(['processing'], false)
    }
    case UPDATE_SECTION_SUCCESS:
      return state.withMutations((map) => {
        map.set('success', true)
        map.set('processing', false)
      })
    case DELETE_SECTION:
      return state
        .deleteIn(['sections', payload])
    case DELETE_SECTION_PROCESSING:
      return state
        .set('deleteProcessing', payload)
    case SET_ONBOARD_DATA:
      return state
        .set('onboardData', payload)
    case SET_TOPICS_DATA:
      return state
        .set('topicsData', payload)
    case SET_LIST_SORT_ORDER_OPTIONS:
      return state
        .set('listSortOrdersData', payload)
    case SET_DISPLAY_MODE_OPTIONS:
      return state
        .set('displayModesData', payload)
    case SET_SECTION_TEMP_VISIBILITY_DATA: {
      const sectionId = _get(payload, 'sectionId')
      const tempVisibility = fromJS(_get(payload, 'visibility'))
      return state
        .setIn(['sections', sectionId, 'tempVisibility'], tempVisibility)
    }
    case SET_CONTENT_REFERENCE_TYPES:
      return state
        .set('contentReferencesTypes', payload)
    case SET_CONTENT_FILTERS:
      return state
        .set('contentFilters', payload)
    default:
      return state
  }
}
